import React from "react";
import { IRCALibraryFilterSelected } from "pages/Corporate/RCA/RCALibrary/components/RCALibraryFilters/RCALibraryFiltersInterfaces";
import { IRCALibraryExtraFilters } from "pages/Corporate/RCA/RCALibrary/components/RCALibraryFilters/useExtraFiltersInterfaces";

export interface IRCALibraryFiltersContext {
    filters: IRCALibraryFilterSelected;
    extraFilters: IRCALibraryExtraFilters;
    handleFiltersChange: (value: IRCALibraryFilterSelected) => void;
    handleExtraFiltersChange: (value: IRCALibraryExtraFilters) => void;
    handleSetFiltersDefault: (value: {
        filters: IRCALibraryFilterSelected;
        extraFilters: IRCALibraryExtraFilters;
    }) => Promise<void>;
    handleRemoveDefaultFilters: () => Promise<void>;
    userFiltersDefault: { filters: IRCALibraryFilterSelected; extraFilters: IRCALibraryExtraFilters } | null;
    loadingDefaultOperations: boolean;
    isFiltersDefault: boolean;
}

export const initialRCALibraryFilters: IRCALibraryFilterSelected = {
    showCompleted: false,
    millsIds: [0],
    selectedAllMillsIds: [],
    meetingTypeIds: [0],
    totalMeetingTypes: 0,
};

export const initialRCALibraryExtraFilters: IRCALibraryExtraFilters = {
    searchText: "",
    startDate: null,
    endDate: null,
    ownerId: [],
    shiftId: [],
    productionLineId: [],
    machineCenterId: [],
    functionalLocationId: [],
    keySuccessFactorId: [],
    failureTypeId: [],
};

export const RCALibraryFiltersContext = React.createContext<IRCALibraryFiltersContext>({
    filters: initialRCALibraryFilters,
    extraFilters: initialRCALibraryExtraFilters,
    handleFiltersChange: () => {},
    handleExtraFiltersChange: () => {},
    handleSetFiltersDefault: async () => {},
    handleRemoveDefaultFilters: async () => {},
    userFiltersDefault: null,
    loadingDefaultOperations: false,
    isFiltersDefault: false,
});

export const initialState = {
    filters: initialRCALibraryFilters,
    extraFilters: initialRCALibraryExtraFilters,
};
